import { Box, Flex, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { Scenario, useScenarioExternalProcessings } from "@nens/ldo/api-v1";

export interface ScenarioExternalProcessingsProps {
  scenario: Scenario;
}

export function ScenarioExternalProcessings({ scenario }: ScenarioExternalProcessingsProps) {
  const externalProcessingsResponse = useScenarioExternalProcessings(scenario.id);

  const processings = externalProcessingsResponse.data?.items ?? [];

  if (processings.length === 0) {
    return null;
  }

  return (
    <>
      {processings.map((processing) => {
        return (
          <Box key={processing.type} rounded="md" border="1px solid #ccc" w="full" my={10}>
            <Flex
              borderBottom="1px solid #ccc"
              py="10px"
              px="14px"
              justifyItems={"flex-start"}
              alignItems={"center"}
            >
              <Text fontWeight={"semibold"}>
                <FormattedMessage
                  id="scenario.external_processing"
                  defaultMessage="Extra processing"
                />
              </Text>
            </Flex>
            <Table size="sm" variant="striped" colorScheme="gray" border="1px solid #ddd">
              <Tbody>
                <Tr>
                  <Td width="20%" valign="top">
                    <FormattedMessage
                      id="scenario.external_processing_type"
                      defaultMessage="Type"
                    />
                  </Td>
                  <Td width="80%" fontWeight="normal">
                    {processing.type}
                  </Td>
                </Tr>
                {(processing.errors ?? []).map((error) => (
                  <Tr key={error}>
                    <Td width="20%" valign="top" fontWeight="bold">
                      <FormattedMessage
                        id="scenario.external_processing_error"
                        defaultMessage="Error"
                      />
                    </Td>
                    <Td width="80%" fontWeight="normal">
                      {error}
                    </Td>
                  </Tr>
                ))}
                {Object.entries(processing.meta_data).map(([key, value]) => (
                  <Tr key={key}>
                    <Td width="20%" valign="top">
                      {key}
                    </Td>
                    <Td width="80%" fontWeight="normal">
                      {typeof value === "number" ? value.toLocaleString() : value}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        );
      })}
    </>
  );
}
